(() => {
  if (window.__stokkiWishlistInitialized) return;
  window.__stokkiWishlistInitialized = true;

  const STORAGE_KEY = 'stokki_saved_products_v1';

  function getSavedProducts() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function saveProducts(products) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    window.dispatchEvent(
      new CustomEvent('stokki:wishlist-changed', { detail: { products } })
    );
  }

  function productMatches(product, productId, productHandle) {
    const idMatches =
      productId &&
      product.id != null &&
      String(product.id) === String(productId);
    const handleMatches =
      productHandle &&
      product.handle &&
      String(product.handle) === String(productHandle);
    return Boolean(idMatches || handleMatches);
  }

  function updateButton(button, isSaved) {
    button.classList.toggle('is-saved', isSaved);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    const label = isSaved
      ? button.dataset.labelRemove
      : button.dataset.labelSave;
    if (label) button.setAttribute('aria-label', label);
  }

  function syncWishlistButtons(products = getSavedProducts()) {
    document.querySelectorAll('.stokki-wishlist-button').forEach((button) => {
      updateButton(
        button,
        products.some((product) =>
          productMatches(
            product,
            button.dataset.productId,
            button.dataset.productHandle
          )
        )
      );
    });
  }

  function syncSavedProductsPage(products = getSavedProducts()) {
    const grid = document.querySelector('[data-stokki-saved-products]');
    if (!grid) return;

    let visibleCount = 0;
    grid.querySelectorAll('[data-stokki-saved-product]').forEach((item) => {
      const isSaved = products.some((product) =>
        productMatches(
          product,
          item.dataset.productId,
          item.dataset.productHandle
        )
      );
      item.hidden = !isSaved;
      if (isSaved) visibleCount += 1;
    });

    const emptyState = document.getElementById('StokkiSavedProductsEmpty');
    if (emptyState) emptyState.hidden = visibleCount > 0;
  }

  function syncWishlistUi() {
    const products = getSavedProducts();
    syncWishlistButtons(products);
    syncSavedProductsPage(products);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.stokki-wishlist-button');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const productId = button.dataset.productId;
    const productHandle = button.dataset.productHandle;
    if (!productId && !productHandle) return;

    const products = getSavedProducts();
    const savedIndex = products.findIndex((product) =>
      productMatches(product, productId, productHandle)
    );

    if (savedIndex >= 0) {
      products.splice(savedIndex, 1);
    } else {
      products.push({ id: productId, handle: productHandle });
    }

    saveProducts(products);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWishlistUi, { once: true });
  } else {
    syncWishlistUi();
  }

  document.addEventListener('shopify:section:load', syncWishlistUi);
  window.addEventListener('stokki:wishlist-changed', syncWishlistUi);
  window.addEventListener('pageshow', syncWishlistUi);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) syncWishlistUi();
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncWishlistUi();
  });
})();